Highcharts.setOptions({
  lang: {
    numericSymbols: null,
    thousandsSep: ' ',
    decimalPoint: ',',
  }
});
